function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 444.163 444.163",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(8 26)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CAF1FF"
    },
    d: "M280.163,314.882l-184,49.2c-17.2,4.4-34.8-5.6-39.2-22.8l-56-208.8c-4.4-17.2,5.6-34.8,22.8-39.2 l46.8-12.8L280.163,314.882L280.163,314.882z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9CE0FF"
    },
    d: "M396.163,26.882c17.6,0,32,14.4,32,32v224c0,17.6-14.4,32-32,32h-288c-17.6,0-32-14.4-32-32v-224 c0-17.6,14.4-32,32-32H396.163L396.163,26.882z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#80D440"
    },
    d: "M424.163,191.682l-47.6-47.6c-3.2-3.2-8-3.2-11.2,0l-96.8,95.2l-60-56.4l-119.2,126.8h336 L424.163,191.682L424.163,191.682z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#62C418"
    },
    d: "M267.363,235.682l-52.4-50.4c-3.2-3.2-8-3.2-11.2,0l-123.6,121.6h120L267.363,235.682 L267.363,235.682z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5F961D"
    },
    d: "M222.163,290.882c-2,0-4-0.8-5.6-2.4c-3.2-3.2-3.2-8,0-11.2l8-8c3.2-3.2,8-3.2,11.2,0 c3.2,3.2,3.2,8,0,11.2l-8,8C226.163,290.082,224.163,290.882,222.163,290.882z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5F961D"
    },
    d: "M94.563,303.682l-11.2-11.6l115.6-113.2c3.2-3.2,7.2-4.8,11.2-4.8s8,1.6,11.2,4.8l46.4,46.4 l-11.2,11.2l-46.4-46.4L94.563,303.682z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5F971D"
    },
    d: "M246.963,265.682c-2,0-4-0.8-5.6-2.4c-3.2-3.2-3.2-8,0-11.2l118.4-117.6c6-6,16.4-6,22.4,0 l47.6,47.6c3.2,3.2,3.2,8,0,11.2s-8,3.2-11.2,0l-47.6-47.6l-118.4,117.6C250.963,264.882,248.963,265.682,246.963,265.682z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#62A2DD"
    },
    d: "M396.163,322.882h-288c-22,0-40-18-40-40v-224c0-22,18-40,40-40h288c22,0,40,18,40,40v224 C436.163,304.882,418.163,322.882,396.163,322.882z M108.163,34.882c-13.2,0-24,10.8-24,24v224c0,13.2,10.8,24,24,24h288 c13.2,0,24-10.8,24-24v-224c0-13.2-10.8-24-24-24H108.163z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFE53C"
    },
    cx: 156.163,
    cy: 106.882,
    r: 24
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3D933"
    },
    d: "M156.163,130.882c13.2,0,24-10.8,24-24s-10.8-24-24-24V130.882L156.163,130.882z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C39215"
    },
    d: "M156.163,138.882c-17.6,0-32-14.4-32-32s14.4-32,32-32s32,14.4,32,32 S173.763,138.882,156.163,138.882z M156.163,90.882c-8.8,0-16,7.2-16,16s7.2,16,16,16s16-7.2,16-16S164.963,90.882,156.163,90.882z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#62A2DD"
    },
    d: "M87.763,373.282c-7.2,0-14-2-20-5.6c-9.2-5.2-16-14-18.4-24.4l-56-208.8c-2.8-10.4-1.2-21.2,4-30.4 s14-16,24.4-18.4l46.8-12.8l4.4,15.6l-47.2,12.4c-6.4,1.6-11.6,5.6-14.8,11.2s-4,12-2.4,18.4l56,208.8c1.6,6.4,5.6,11.6,11.2,14.8 c5.6,3.2,12,4,18.4,2.4l184-49.2l4,15.6l-184,49.2C94.963,372.882,91.363,373.282,87.763,373.282z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.649ff03e19c394153ee9963c26aaa39d.svg";
export { ForwardRef as ReactComponent };